import Container from './Container'
import { Header } from './Header'
import Footer from './Footer'
import Layout from './Layout'
import Content from './Content'
import Sidebar from './Sidebar'
import NavBottom from './NavBottom'
import PageTitle from './PageTitle'

import Col from 'antd/lib/grid/col'
import Row from 'antd/lib/grid/row'
import 'antd/lib/grid/style/index.less'

export {
  Container,
  Header,
  Footer,
  Layout,
  Content,
  Sidebar,
  NavBottom,
  PageTitle,
  Col,
  Row
}
